import { useState, useEffect } from 'react'
import { Table, Button } from 'react-bootstrap'
import { FaTrash, FaRegEdit } from 'react-icons/fa'
import { toast } from 'react-toastify'
import { useParams } from '../../../Providers/ParamsProvider'
import AddEditHomePageSliderModal from '../Modals/AddEditHomePageSliderModal'
import LoadingSpinner from '../../../Components/Components/LoadingSpinner'
import { useConfig } from '../../../Providers/ConfigProvider'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import ShowImageModal from '../../../Components/Components/Modals/ShowImageModal'
import useConfirmDelete from '../../../Hooks/useConfirmDelete'

const AdminPanelSlider = () => {
    const { dataUrl } = useConfig()
    const { handleGetHomePageSliderItems, handleDeleteHomePageSliderItem } = useParams()
    const { requestDelete, confirmModal } = useConfirmDelete()
    const [sliderItems, setSliderItems] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [editItem, setEditItem] = useState(null)
    const [imageModalObj, setImageModalObj] = useState({ show: false, fileName: '', header: '' })

    useEffect(() => {
        const fetchSliderItems = async () => {
            setIsLoading(true)
            const items = await handleGetHomePageSliderItems()
            setSliderItems(items)
            setIsLoading(false)
        }

        fetchSliderItems()
    }, [])

    const refreshSliderItems = async () => {
        const items = await handleGetHomePageSliderItems(true) //wymuszamy pobranie z API, by zaciągnąć aktualny stan (np. nowe Id)
        setSliderItems(items)
    }

    const handleOpenAdd = () => {
        setEditItem(null)
        setShowModal(true)
    }

    const handleOpenEdit = (item) => {
        setEditItem(item)
        setShowModal(true)
    }

    const handleDeleteItem = async (id) => {
        const success = await handleDeleteHomePageSliderItem(id)
        if (success) {
            setSliderItems(prev => prev.filter(item => item.id !== id))
            toast.success('Usunięto element slidera.')
        } else {
            toast.error('Błąd podczas usuwania elementu!')
        }
    }

    if (isLoading) {
        return <LoadingSpinner />
    }
    return (<>
        {confirmModal}
        <AddEditHomePageSliderModal
            show={showModal}
            onHide={() => setShowModal(false)}
            onSaved={refreshSliderItems}
            editItem={editItem}
        />
        <ShowImageModal
            show={imageModalObj.show}
            onHide={() => setImageModalObj({ show: false, fileName: '', header: '' })}
            header={imageModalObj.header}
            imageSrc={`${dataUrl}/banery/${imageModalObj.fileName}`}
            altText={imageModalObj.header}
        />

        <div className='d-flex flex-column border-bottom pb-2 mb-3'>
            <h5 >Elementy slidera na stronie głównej</h5>
            <b className='primary-accent-color-text'>{`Plik musi zawierać nazwę pliku + rozszerzenie i odnoscić się do dysku sieciowego udostępnionego pod adresem ${dataUrl} ,pliki muszą znajdować sie w podfolderze /banery`}</b>
            <b className='primary-accent-color-text'>Url przekierowuje adres na stronie eHandlu</b>
        </div>
        <Table hover className='mb-4' responsive style={{ minWidth: '760px' }}>
            <thead>
                <tr>
                    <th style={{ width: '18%' }}>Nazwa</th>
                    <th style={{ width: '27%' }}>Opis</th>
                    <th style={{ width: '18%' }}>Plik</th>
                    <th style={{ width: '18%' }}>URL</th>
                    <th className='text-center' style={{ width: '9%' }}>Aktywny</th>
                    <th className='text-end' style={{ width: '10%' }}></th>
                </tr>
            </thead>
            <tbody>
                {sliderItems.length === 0 && (
                    <tr>
                        <td colSpan={6} className='text-center text-muted py-3'>
                            Brak elementów slidera.
                        </td>
                    </tr>
                )}
                {sliderItems.map(item => (
                    <tr key={item.id}>
                        <td className='align-middle'>{item.name}</td>
                        <td className='align-middle'>{item.description}</td>
                        <td className='align-middle text-break' >
                            <div>
                                {item.fileName}
                                <FaEye className='ms-2 primary-accent-color-text element-pointer' onClick={() => {
                                    setImageModalObj({ show: true, fileName: item.fileName, header: item.description })
                                }} />
                            </div>
                        </td>
                        <td className='align-middle text-break'>{item.url}</td>
                        <td className='align-middle text-center'>
                            {item.isActive ? 'Tak' : 'Nie'}
                        </td>
                        <td className='align-middle text-end'>
                            <div className='d-flex align-items-center justify-content-end flex-nowrap gap-2'>
                                <FaRegEdit
                                    size={20}
                                    className='element-pointer'
                                    onClick={() => handleOpenEdit(item)}
                                    title='Edytuj'
                                />
                                <Button
                                    size='sm'
                                    variant='outline-danger'
                                    onClick={() => requestDelete('Czy na pewno usunąć element slidera?', () => handleDeleteItem(item.id))}
                                    title='Usuń'
                                >
                                    <FaTrash size={13} />
                                </Button>
                            </div>
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
        <div className='d-flex justify-content-end'>
            <button className='btn btn-primary' onClick={handleOpenAdd}>Dodaj element</button>
        </div>
    </>)
}

export default AdminPanelSlider
